const medicineMngt = {
    namespaced: true,
    state : {
        medicineCd : '',
        medicineNm : '',
        medHrbDtlSeq : '',
        chkInfo : '',
        status : '',
        productCodeUuid : '',
    },
    getters: {
        getMedicineCd (state) {
            return state.medicineCd
        },
        getMedicineNm (state) {
            return state.medicineNm
        },
        getMedHrbDtlSeq (state) {
            return state.medHrbDtlSeq
        },
        getChkInfo (state) {
            return state.chkInfo
        },
        getStatus (state) {
            return state.status
        },
        getProductCodeUuid (state) {
            return state.productCodeUuid
        },
    },
    mutations: {
        setMedicineCd (state, payload) {
            state.medicineCd = payload
        },
        setMedicineNm (state, payload) {
            state.medicineNm = payload
        },
        setMedHrbDtlSeq (state, payload) {
            state.medHrbDtlSeq = payload
        },
        setChkInfo (state, payload) {
            state.chkInfo = payload
        },
        setStatus (state, payload) {
            state.status = payload
        },
        setProductCodeUuid (state, payload) {
            state.productCodeUuid = payload
        },

    },
    actions: {
        setMedicineCd ({commit}, payload) {
            commit('setMedicineCd', payload)
        },
        setMedicineNm ({commit}, payload) {
            commit('setMedicineNm', payload)
        },
        setMedHrbDtlSeq ({commit}, payload) {
            commit('setMedHrbDtlSeq', payload)
        },
        setChkInfo ({commit}, payload) {
            commit('setChkInfo', payload)
        },
        setStatus ({commit}, payload) {
            commit('setStatus', payload)
        },
        setProductCodeUuid ({commit}, payload) {
            commit('setProductCodeUuid', payload)
        },
        setMedicineMngtinit ({commit}) {
            commit('setMedicineCd','');
            commit('setMedicineNm','');
            commit('setMedHrbDtlSeq','');
            commit('setChkInfo','');
            commit('setStatus','');
            commit('setProductCodeUuid','');
        },
    }
}


export default medicineMngt